import React from "react";
// import { FaTwitter, FaLinkedin } from "react-icons/fa";
import Logo from "../../assets/logo.png";
import { Button } from "../Buttons";
import LinkedInIcon from "../../assets/Icons/LinkedInIcon";
import InstaIcon from "../../assets/Icons/InstaIcon";
import FacebookIcon from "../../assets/Icons/FacebookIcon";
import YoutubeIcon from "../../assets/Icons/YoutubeIcon";
const AboutUS = [
  { title: "Team", link: "/team" },
  { title: "Our Story", link: "/our-story" },
  { title: "Careers", link: "/careers" },
  { title: "Code of Conduct", link: "/code-of-conduct" },
  { title: "Mandatory Disclosure", link: "/mandatory-disclosure" },
];

const EmiCalc = [
  { title: "Calculator", link: "/team" },
  { title: "Credit Score", link: "/our-story" },
  { title: "Things to Know", link: "/careers" },

];

const Lending = [
  { title: "SAFL", link: "/team" },
  { title: "Disclosure", link: "/our-story" },

];

const Contact = [
  { title: "Office", link: "/team" },
  { title: "Contact Number", link: "/our-story" },
  { title: "Contact Timing", link: "/careers" },
  { title: "Contact Form", link: "/careers" },
];

const Support = [
  { title: "For Loan", link: "/team" },
  { title: "Grievance Redressal Policy", link: "/our-story" },
  { title: "Grievance Redressal", link: "/careers" },

];
const Footer = (props) => {


  const FooterList = ({ list, title }) => {
    return (
      <div className="">
        <div className={`text-[18px] leading-[16px] tacking-[0.2px] text-[#0F1922]`}>
          {title}
        </div>
        <ul className="mt-[24px] flex flex-col gap-[16px]">
          {list.map((item, index) => (
            <li key={index}>
              <a href={item.link} className="text-[#424952] text-opacity-[88%]">
                {item.title}
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className={` bg-[rgb(252,248,242)] mt-[34px] md:mt-[134px]`} >
      <div className={`py-[90px] px-[20px] md:px-[60px] mx-0 md:mx-[55px] md:bg-white md:border-[1px] rounded-[25px] ${props?.custumeClass || ""}`}>
        <div className="flex flex-col lg:flex-row gap-[12px]">
          <div className="col-span-2 md:col-span-2 3xl:col-span-1 flex items-center lg:items-start">
            <div className="flex flex-col">
              <img src={Logo} className="object-contain max-w-[250px]" />
              <div>
                <div className="flex mt-4 gap-[10px] items-center">
                  <a href="https://linkedin.com">
                    <LinkedInIcon />
                  </a>
                  <a href="https://instagram.com">
                    <InstaIcon />
                  </a>
                  <a href="https://facebook.com">
                    <FacebookIcon />
                  </a>
                  <a href="https://youtube.com">
                    <YoutubeIcon />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-3 lg:grid-cols-5 gap-4 mb-10">
            <div className="col-span-2 md:col-span-1 lg:col-span-2 xl:col-span-1">
              <FooterList list={AboutUS} title="About Us" />
            </div>
            <div className="col-span-1 lg:col-span-2 xl:col-span-1">
              <FooterList list={EmiCalc} title="EMI Calculator" />
            </div>
            <div className="col-span-2 md:col-span-1 3xl:col-span-1 self-start">
              <FooterList list={Lending} title="Lending Partners" />
            </div>
            <div className="col-span-1 lg:col-span-2   xl:col-span-1">
              <FooterList list={Contact} title="Contact" />
            </div>
            <div className="col-span-1 md:col-span-1 lg:col-span-1 lg:flex  3xl:justify-start 3xl:col-span-1 self-start">
              <FooterList list={Support} title="Support" />
            </div>
          </div>
        </div>
        <div className="hidden  flex-row my-[40px]">
          <input type="input" placeholder="Enter your mobile number" className="bg-[#F8F8F8] rounded-[12px] p-[15px] w-[325px]" /> <Button title="Sign Up" className="ml-[8px]" />
        </div>
        <div className="border-t-[1px] border-[#000] py-[32px] flex justify-between">
          <p className="text-[#424952] font-[400] text-[15px] leading-[16px] tracking-[0.2px]">
            © 2023 FastFin
          </p>
          <div className="flex gap-[12px] md:gap-[40px]" >
            <p className="text-[#424952] font-[400] text-[15px] leading-[16px] tracking-[0.2px]">
              Privacy Policy
            </p>
            <p className="text-[#424952] font-[400] text-[15px] leading-[16px] tracking-[0.2px]">
              Terms & Conditions
            </p>
            <p className="text-[#424952] font-[400] text-[15px] leading-[16px] tracking-[0.2px]">
              Other Disclosures
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
